import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";

// Pages
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import RestorationServicesPage from "./pages/RestorationServicesPage";
import CrashRepairsPage from "./pages/CrashRepairsPage";
import VehicleAccessoriesPage from "./pages/VehicleAccessoriesPage";
import CustomPaintPage from "./pages/CustomPaintPage";
import SkiBoatRVPage from "./pages/SkiBoatRVPage";
import TowingPage from "./pages/TowingPage";
import MechanicalRepairsPage from "./pages/MechanicalRepairsPage";
import GalleryPage from "./pages/GalleryPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/restoration-services" element={<RestorationServicesPage />} />
            <Route path="/crash-repairs" element={<CrashRepairsPage />} />
            <Route path="/vehicle-accessories" element={<VehicleAccessoriesPage />} />
            <Route path="/custom-paint" element={<CustomPaintPage />} />
            <Route path="/ski-boat-rv" element={<SkiBoatRVPage />} />
            <Route path="/towing" element={<TowingPage />} />
            <Route path="/mechanical-repairs" element={<MechanicalRepairsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/privacy" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
